var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "info-icon",
    fillRule: "nonzero",
    fill: "#FFB132"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,10 C14.486,10 10,14.4860606 10,20.0000606 C10,25.5140606 14.486,30 20,30 C25.514,30 30,25.5140606 30,20.0000606 C30,14.4860606 25.514,10 20,10 Z M20,28 C15.5887407,28 12,24.4112593 12,20.0000593 C12,15.5888593 15.5887407,12 20,12 C24.4112593,12 28,15.5888593 28,20.0000593 C28,24.4112593 24.4112,28 20,28 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9998788,14.2424242 C19.3316364,14.2424242 18.788,14.7864242 18.788,15.4550909 C18.788,16.1231515 19.3316364,16.6666667 19.9998788,16.6666667 C20.6681212,16.6666667 21.2117576,16.1231515 21.2117576,15.4550909 C21.2117576,14.7864242 20.6681212,14.2424242 19.9998788,14.2424242 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,18.4848485 C19.4979394,18.4848485 19.0909091,18.8918788 19.0909091,19.3939394 L19.0909091,24.8484848 C19.0909091,25.3505455 19.4979394,25.7575758 20,25.7575758 C20.5020606,25.7575758 20.9090909,25.3505455 20.9090909,24.8484848 L20.9090909,19.3939394 C20.9090909,18.8918788 20.5020606,18.4848485 20,18.4848485 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.3114ade02789f217f3cba434e6cf5e3b.svg";
export { ForwardRef as ReactComponent };